var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _g3, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 427,
    viewBox: "0 0 1440 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M656.001 435.042H730.084H970.775V357.354H730.088V357.338C720.489 357.338 712.728 364.808 711.976 374.298C708.821 372.892 705.336 372.095 701.67 372.095C687.492 372.095 675.997 383.765 675.997 398.158C675.997 398.893 676.048 399.612 676.103 400.33C675.474 400.264 674.832 400.209 674.179 400.209C664.144 400.209 656.001 424.919 656.001 435.042Z",
    fill: "#D4F0E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161 306.666C161 327.759 145.83 344.849 145.83 344.849C145.83 344.849 130.661 327.759 130.661 306.666C130.661 285.573 145.83 268.483 145.83 268.483C145.83 268.483 161 285.573 161 306.666Z",
    fill: "#D4F0E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.863 302.008H146.824V366.104H144.863V302.008Z",
    fill: "#99CBC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.776 295.917C115.776 320.233 92.9534 339.933 92.9534 339.933C92.9534 339.933 70.1304 320.233 70.1304 295.917C70.1304 271.602 92.9534 251.901 92.9534 251.901C92.9534 251.901 115.776 271.602 115.776 295.917Z",
    fill: "#D4F0E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1116 292.012H94.1049V364.385H91.1116V292.012Z",
    fill: "#99CBC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4784 300.362C55.4784 319.682 41.5841 335.335 41.5841 335.335C41.5841 335.335 27.6898 319.682 27.6898 300.362C27.6898 281.042 41.5841 265.389 41.5841 265.389C41.5841 265.389 55.4784 281.042 55.4784 300.362Z",
    fill: "#D4F0E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6985 296.097H42.4945V354.805H40.6985V296.097Z",
    fill: "#99CBC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.456 374.938C17.6685 334.814 -26.9999 358.142 -26.9999 358.142V509.776H1008.39C1008.39 509.776 815.075 364.99 667.294 364.99C457.07 364.99 478.669 434.658 214.437 374.927L214.456 374.938Z",
    fill: "#B5D8D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M841.455 282.594C841.488 283.612 841.538 284.697 841.571 285.88C841.422 283.3 841.438 282.101 841.455 282.594Z",
    fill: "#F3F3F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.31 350.47C1241.92 348.137 1242.45 345.458 1242.9 342.517C1239.53 367.903 1232.87 391.4 1220.04 418.659C1220.04 418.659 1209.19 445.705 1180.69 475.165C1164.43 492.04 1142.36 509.687 1113.29 523.522C1107.38 526.348 1101.18 528.994 1094.67 531.459C1085.38 534.991 1068.45 537.439 1045.29 536.651C1042.94 536.569 1040.52 536.454 1038.03 536.306C1036.34 536.207 1034.64 536.092 1032.9 535.961C1031.95 535.796 1031.03 535.616 1030.1 535.435C1026.82 534.794 1023.59 534.088 1020.41 533.299C1019.05 532.97 1017.76 532.642 1016.53 532.329C1015.29 532.001 1014.1 531.689 1012.97 531.376C1008.23 530.045 1003.61 528.583 999.106 526.973C1002.83 528.074 1017.46 532.001 1038.03 533.02C1040.37 533.135 1042.8 533.217 1045.29 533.25C1064.84 533.512 1088.67 530.916 1113.29 521.353C1136.02 512.563 1159.42 497.808 1180.69 473.9C1205.09 446.46 1226.71 406.944 1241.31 350.47Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.26 0V273.282C1246.26 289.73 1246.03 304.485 1245.2 318.304C1246.52 292.852 1245.63 265.297 1245.63 265.297V0.44364C1245.74 0.361485 1245.83 0.29576 1245.91 0.246467C1246.13 0.0821558 1246.24 0 1246.26 0Z",
    fill: "#F3F3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1041 295.268V474.812C1038.62 475.483 1036.21 476.038 1033.76 476.517C1025.23 478.203 1016.39 478.874 1008.02 478.989C1000.97 479.085 993.942 478.567 987 477.456V290L1033.76 294.559L1041 295.268Z",
    fill: "#D4F0E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.72 305.955C1157.91 363.988 1144.21 408.994 1115.17 441.199V182.787L1161.67 198.43C1161.67 198.43 1162.01 238.009 1161.67 263.365C1161.44 280 1161.67 286.473 1160.72 305.955Z",
    fill: "#D4F0E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_203_7741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987 290V477C972.853 474.745 959.037 470.025 946 462.917V325.409L987 290Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_203_7741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1115.17 182.762V441.19C1100.82 457.096 1082.23 469.748 1058.12 478.949C1054.64 480.28 1050.96 481.364 1047.17 482.252C1044.78 482.827 1042.36 483.303 1039.91 483.714V239.17L1115.17 182.762Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_203_7741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1245.2 318.312C1245.16 318.558 1245.21 326.98 1245.2 327.226C1244.7 335.196 1243.96 334.677 1242.94 342.153C1242.94 342.268 1242.93 342.4 1242.9 342.515C1242.45 345.456 1241.92 348.134 1241.3 350.467C1226.71 406.941 1205.09 446.458 1180.69 473.898C1159.42 497.805 1136.02 512.56 1113.29 521.351C1088.67 530.914 1064.84 533.51 1045.29 533.247C1042.8 533.214 1040.37 533.132 1038.03 533.017C1017.46 531.998 1002.83 528.071 999.105 526.971C999.089 526.971 999.056 526.954 999.039 526.954C996.372 526.018 993.755 525.032 991.171 523.996C976.196 518.048 962.529 510.72 950.172 502.554C915.534 479.682 888.212 472.679 874.38 449.035C843.08 417.735 835.863 483.259 834.786 457.134C835.995 476.654 874.38 422.489 910.929 444.536C922.723 455.939 935.992 465.025 950.172 471.663C963.208 477.776 977.024 481.834 991.171 483.773C998.128 484.726 1005.17 485.17 1012.24 485.088C1020.62 484.989 1029.49 484.414 1038.03 482.968C1040.49 482.557 1042.9 482.081 1045.29 481.506C1049.08 480.618 1052.76 479.534 1056.24 478.203C1080.36 469.002 1098.94 456.35 1113.29 440.444C1142.33 408.239 1153.27 371.124 1158.84 305.2C1159.44 298.151 1159.79 262.61 1159.79 262.61V63.9251C1159.79 63.9251 1237.83 6.0711 1245.63 0.45166V265.305C1245.63 265.305 1246.52 292.86 1245.2 318.312Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.07 61.3702V309.727C1313.07 312.388 1313.02 315.132 1312.92 317.926C1309.57 415.132 1248.28 483.42 1180.69 516.775C1160.24 526.864 1139.21 533.749 1119.05 537.281C1117.12 537.626 1115.2 537.922 1113.29 538.201C1088.11 541.898 1064.49 540.715 1045.29 538.004C1042.79 537.659 1040.37 537.281 1038.03 536.887C1035.27 536.427 1032.62 535.934 1030.1 535.424C1026.62 534.718 1023.39 533.995 1020.41 533.288C1019.05 532.96 1017.76 532.631 1016.53 532.319C1015.29 531.99 1014.1 531.678 1012.97 531.366C1004.34 529 999.073 527.028 998.278 526.716C998.411 526.749 998.659 526.831 999.04 526.946C999.057 526.946 999.09 526.962 999.106 526.962C1002.83 528.063 1017.46 531.99 1038.03 533.009C1040.37 533.124 1042.81 533.206 1045.29 533.239C1064.84 533.502 1088.67 530.906 1113.29 521.343C1136.02 512.552 1159.42 497.797 1180.69 473.89C1205.09 446.45 1227.18 408.74 1241.31 350.459C1241.92 348.126 1242.45 345.448 1242.9 342.507C1242.93 342.392 1242.95 342.26 1242.95 342.145C1244.01 335.392 1244.7 327.357 1245.15 319.043C1245.15 318.797 1245.2 318.304 1245.2 318.304L1245.63 265.297V0C1245.63 0 1245.73 0.0821557 1245.91 0.246467C1245.99 0.328623 1246.11 0.427209 1246.26 0.558658C1253.08 6.67103 1313.07 61.1731 1313.07 61.3702Z",
    fill: "#D4F0E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.94 137.681V386.323C1335.94 401.288 1336.16 414.713 1336.91 427.285C1335.7 404.128 1336.52 379.058 1336.52 379.058V138.084C1336.41 138.01 1336.34 137.95 1336.26 137.905C1336.06 137.755 1335.96 137.681 1335.94 137.681Z",
    fill: "#F3F3F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.77 422.669C1410.2 493.389 1426.9 404.21 1462.29 443.456V108.014L1405.62 127.076C1405.62 127.076 1405.21 175.308 1405.62 206.208C1405.89 226.48 1405.62 398.927 1406.77 422.669Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.91 427.29C1336.94 427.514 1336.89 435.177 1336.91 435.401C1337.36 442.652 1338.04 442.18 1338.96 448.982C1338.96 449.087 1338.97 449.206 1339 449.311C1339.41 451.987 1339.89 454.424 1340.45 456.547C1353.73 507.929 1373.4 543.882 1395.6 568.848C1414.95 590.6 1436.25 604.025 1456.92 612.023C1479.32 620.724 1501.01 623.086 1518.79 622.847C1521.05 622.817 1523.27 622.742 1525.39 622.637C1544.11 621.71 1557.42 618.137 1560.81 617.136C1560.83 617.136 1560.86 617.121 1560.87 617.121C1563.3 616.269 1565.68 615.372 1568.03 614.43C1581.66 609.018 1594.09 602.351 1605.33 594.921C1636.85 574.111 1659.06 547.381 1671.65 525.868C1699.31 478.627 1703.12 422.431 1704.1 398.661C1703 416.422 1695.06 489.944 1641.04 542.133C1630.31 552.508 1618.24 560.776 1605.33 566.815C1593.47 572.376 1580.9 576.069 1568.03 577.833C1561.7 578.7 1555.3 579.104 1548.86 579.029C1541.23 578.939 1533.17 578.416 1525.39 577.101C1523.16 576.727 1520.96 576.293 1518.79 575.77C1515.34 574.963 1512 573.976 1508.83 572.765C1486.89 564.393 1469.98 552.882 1456.92 538.411C1430.5 509.11 1420.55 475.341 1415.48 415.36C1414.93 408.947 1414.62 376.611 1414.62 376.611V195.839C1414.62 195.839 1343.62 143.202 1336.52 138.089V379.062C1336.52 379.062 1335.7 404.133 1336.91 427.29Z",
    fill: "#B5D8D1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.16 193.518V419.482C1275.16 421.904 1275.2 424.4 1275.29 426.942C1278.34 515.384 1334.1 577.515 1395.6 607.862C1414.21 617.042 1433.34 623.306 1451.68 626.52C1453.44 626.834 1455.19 627.103 1456.92 627.357C1479.83 630.721 1501.32 629.644 1518.79 627.177C1521.07 626.863 1523.27 626.52 1525.39 626.161C1527.91 625.742 1530.32 625.294 1532.61 624.83C1535.78 624.188 1538.72 623.53 1541.43 622.887C1542.67 622.588 1543.84 622.289 1544.96 622.005C1546.09 621.706 1547.17 621.422 1548.2 621.138C1556.05 618.985 1560.84 617.191 1561.57 616.907C1561.44 616.937 1561.22 617.012 1560.87 617.116C1560.86 617.116 1560.83 617.131 1560.81 617.131C1557.42 618.133 1544.11 621.706 1525.39 622.633C1523.27 622.737 1521.05 622.812 1518.79 622.842C1501.01 623.081 1479.32 620.719 1456.92 612.018C1436.24 604.02 1414.95 590.596 1395.6 568.844C1373.4 543.878 1353.31 509.568 1340.45 456.542C1339.89 454.419 1339.41 451.982 1339 449.306C1338.97 449.202 1338.96 449.082 1338.96 448.977C1337.99 442.833 1337.36 435.523 1336.95 427.958C1336.95 427.734 1336.91 427.285 1336.91 427.285L1336.52 379.058V137.681C1336.52 137.681 1336.43 137.755 1336.26 137.905C1336.18 137.98 1336.08 138.069 1335.94 138.189C1329.73 143.75 1275.16 193.338 1275.16 193.518Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_203_7741",
    x: 946,
    y: 290,
    width: 45.4993,
    height: 192.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_203_7741"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_203_7741",
    result: "effect2_innerShadow_203_7741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_203_7741",
    x: 1039.91,
    y: 182.762,
    width: 79.755,
    height: 306.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_203_7741"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_203_7741",
    result: "effect2_innerShadow_203_7741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_203_7741",
    x: 834.786,
    y: 0.45166,
    width: 415.637,
    height: 538.213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_203_7741"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_203_7741",
    result: "effect2_innerShadow_203_7741"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero_bg.3eef8faf25a70ac7d855773d0b921770.svg";
export { ForwardRef as ReactComponent };